import _ from 'lodash'

import { EventLogo } from '@/shared/ui/EventLogo'
import type { DigitalProduct } from '@/types/digitalProduct'

import { resolveAuthTagline } from './auth-branding'
import { AuthValueProps } from './AuthValueProps'

type AuthHeroProps = {
  digitalProduct?: DigitalProduct
  showValueProps?: boolean
}

/**
 * Hero do shell de autenticação: a marca do evento é o sinal principal.
 * Sem arte decorativa placeholder — o espaço visual fica com a logo.
 */
export function AuthHero({
  digitalProduct,
  showValueProps = false
}: AuthHeroProps) {
  const logoUrl = _.get(digitalProduct, 'logo.file.url') as string | undefined
  const tagline = resolveAuthTagline(digitalProduct)

  return (
    <header className="flex w-full flex-col items-center gap-[clamp(0.75rem,2.5dvh,1.5rem)] text-center short:gap-2">
      <div className="flex w-full max-w-[360px] flex-col items-center gap-3 short:gap-2">
        {logoUrl ? <EventLogo src={logoUrl} alt="" variant="auth" /> : null}
        <p className="text-sm font-semibold leading-snug text-gray-700">
          {tagline}
        </p>
      </div>

      {showValueProps ? (
        <div className="w-full max-w-[320px]">
          <AuthValueProps />
        </div>
      ) : null}
    </header>
  )
}
